// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Y4-z"};